/** EMIMS tab icon — matches sidebar: primary-500 square + Lucide heart */
export const EMIMS_FAVICON_SVG = [
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">',
  '<rect width="32" height="32" rx="8" fill="#3b82f6"/>',
  '<g transform="translate(4,4)">',
  '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" fill="#fff"/>',
  '</g></svg>',
].join('');

export const EMIMS_FAVICON_DATA_URL = `data:image/svg+xml,${encodeURIComponent(EMIMS_FAVICON_SVG)}`;

export function applyEmimsFavicon() {
  document.querySelectorAll('link[rel*="icon"]').forEach((el) => el.remove());

  const icon = document.createElement('link');
  icon.rel = 'icon';
  icon.type = 'image/svg+xml';
  icon.href = EMIMS_FAVICON_DATA_URL;
  document.head.appendChild(icon);

  const apple = document.createElement('link');
  apple.rel = 'apple-touch-icon';
  apple.href = '/emims-icon-180.png';
  document.head.appendChild(apple);
}
